exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./ClientApp/app/components/quote-settings/orgs/create-edit-org-modal/create-edit-org-modal.component.css
// module id = 742
// module chunks = 0